import { gql } from '@apollo/client'

export const MARK_AS_READ = gql`
  mutation MARK_AS_READ($id: Int!) {
    notifications {
      markAsRead(id: $id)
    }
  }
`

export interface MarkAsReadVariables {
  id: number
}

export interface MarkAsReadResponse {
  notifications: {
    markAsRead: boolean
  }
}

export const MARK_AS_DELIVERED = gql`
  mutation MARK_AS_DELIVERED($ids: [Int!]!) {
    notifications {
      markAsDelivered(ids: $ids)
    }
  }
`

export interface MarkAsDeliveredVariables {
  ids: [number]
}

export interface MarkAsDeliveredResponse {
  notifications: {
    markAsDelivered: boolean
  }
}
